<script>
import {createHelpers} from "vuex-map-fields";

const {mapFields} = createHelpers({
  getterType: 'scholarship_meeting/getPayloadMeeting',
  mutationType: 'scholarship_meeting/updatePayloadMeeting',
});
export default {
  name: "TheMeetingDatePicker",

  props: {
    // visible: Boolean,
  },

  data() {
    return {
      dateMeeting: null,
      visible: false,
    };
  },

  computed: {

    ...mapFields([
      "meeting_date"
    ]),

    textFieldDate() {
      return new Date(this.meeting_date).toLocaleDateString('en-GB').toString();
    }
  },

  methods: {

  },


}
</script>

<template>
  <v-menu
    ref="menu"
    v-model="visible"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        outlined
        dense
        :value="textFieldDate"
        color="teal darken-3"
        label="Дата"
        readonly
        class="rounded-xl"
        v-bind="attrs"
        v-on="on"
      >
        <template #append>
          <v-icon
          >
            fa fa-calendar
          </v-icon>
        </template>
      </v-text-field>
    </template>
    <v-date-picker
      color="teal darken-3"
      v-model="meeting_date"
      header-color="teal darken-3"
      locale="ru"
      scrollable
      elevation="15"
    >
      <v-spacer></v-spacer>
      <v-btn
        text
        color="primary"
        @click="visible = false"
      >
        Отмена
      </v-btn>
      <v-btn
        text
        color="primary"
        @click="visible = false"
      >
        OK
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<style scoped>

</style>